module.exports = __webpack_public_path__ + "img/chevronDownSort.b94f45a6.svg";